import style from "./DayButton.module.scss";
import cn from "classnames";

export function DayButton({
  text,
  pickerDate,
  isSelected,
  onClick,
}: {
  text: number;
  pickerDate: {
    year: number;
    month: number;
  };
  isSelected: boolean;
  onClick: () => void
}) {
  const currentDate = new Date();
  const isToday =
    currentDate.getDate() === text &&
    currentDate.getFullYear() === pickerDate.year &&
    currentDate.getMonth() === pickerDate.month;

  return (
    <button
      className={cn(style.day, isToday && style.today, isSelected && style.selected)}
      onClick={onClick}
    >
      {text}
    </button>
  );
}